module.exports = __webpack_public_path__ + "img/user_icon.cd7e245b.svg";